module.exports = __webpack_public_path__ + "img/20200514_152345.82e7635f.jpg";